import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-toilet",
  "use": "icon-si-glyph-toilet-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-toilet\" id=\"icon-si-glyph-toilet\"><title>919</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\"><path d=\"M8.777,15.974 L2.487,15.974 C2.487,15.974 5.5,9.994 1.013,9.994 L1.013,8.001 L12.979,8.001 C12.979,8.001 13.066,9.218 10.867,10.687 C7.48,12.947 8.777,15.974 8.777,15.974 L8.777,15.974 Z\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"6\" width=\"7.979\" height=\"0.979\" class=\"si-glyph-fill\" /><path d=\"M0.012,0.009 L0.012,6.983 L4,6.983 L4,0.009 L0.012,0.009 L0.012,0.009 Z M3,3.036 L2,3.036 L2,1 L3,1 L3,3.036 L3,3.036 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-toilet.svg
// module id = atxO
// module chunks = 62